import { Box } from "@mui/material";
import SourceListItem from "./SourceListItem";

type SourcesViewProps = {
  responseSources: any[];
  onSourceClick: (sdrId: number | null, sourceId: number | null) => void;
};

const SourceListView = ({
  responseSources,
  onSourceClick,
}: SourcesViewProps) => {
  return (
    <Box
      data-testid="aa-src-list"
      sx={{
        width: "100%",
        p: 1.5,
        "& > *:last-child": {
          mb: 0,
        },
      }}
    >
      {responseSources.map((source, i) => (
        <SourceListItem
          key={i}
          index={i}
          source={source.data_chunk}
          onSourceClick={onSourceClick}
        />
      ))}
    </Box>
  );
};

export default SourceListView;
